export interface HttpErrorOptions extends ErrorOptions {
  statusCode?: number;
  /** Value of the `X-Error-Code` response header, if present. */
  errorCode?: string;
  /** Value of the `Retry-After` response header in seconds, if present. */
  retryAfter?: number;
  /** Raw `detail` field from the response JSON (string or Pydantic validation array). */
  detail?: unknown;
  /** Email address embedded in the error response body, if present. */
  email?: string;
}

export class HttpError extends Error {
  public statusCode?: number;
  public errorCode?: string;
  public retryAfter?: number;
  public detail?: unknown;
  public email?: string;

  constructor(message?: string, options?: HttpErrorOptions) {
    super(message, options);
    this.name = this.constructor.name;
    this.statusCode = options?.statusCode;
    this.errorCode = options?.errorCode;
    this.retryAfter = options?.retryAfter;
    this.detail = options?.detail;
    this.email = options?.email;
  }

  override toString(): string {
    return `${this.name}: ${this.message} (HTTP ${this.statusCode})`;
  }
}

export class ServerError extends HttpError {}

export class ClientError extends HttpError {}

export class AuthenticationError extends ClientError {}

export class TimeoutError extends Error {
  constructor(message?: string) {
    super(message || 'Request timed out');
    this.name = this.constructor.name;
  }
}
